import React from "react";
import PhysicalBanner from "./PhysicalBanner";
import PhysicalSecurity from "./PhysicalSecurity";
import PhysicalClientLogo from "./PhysicalClientLogo";
import PhysicalDocs from "./PhysicalDocs";
import PhysicalCycle from "./PhysicalCycle";
import PhysicalDocsLeft from "./PhysicalDocsLeft";
import PhysicalGrowth from "./PhysicalGrowth";
import PhysicalStorage from "./PhysicalStorage";
import PhysicalAfter from "./PhysicalAfter";
import PhysicalTool from "./PhysicalTool";
import PhysicalAdopt from "./PhysicalAdopt";
import PhysicalFaq from "./PhysicalFaq";

const physicalData = {
  img: "/assets/images/physical-banner-image.webp",
  head: "Transform Physical Storage into a Secure, Intelligent Business Asset",
  btn: "Contact Us",
  slug: "/contact",
};

const countData = {
  title: "Fewer Tools, Fewer Costs",
  para: "Cut software bloat while keeping teams fast, clear and connected.",
  btn: "Unlock Your savings",
  stats: [
    {
      number: "10",
      suffix: "X",
      desc: "Operational Efficiency"
    },
    {
      number: "39",
      suffix: "%",
      desc: "More Productive"
    },
    {
      number: "72",
      suffix: "%",
      desc: "Cost Savings"
    },
  ]
}

const securityData = {
  head: "Secure. Structured. Always Accessible.",
  desc: `<p>Modern organizations still rely on physical documents, but managing them should not feel outdated. Dox and Box transforms traditional record asset storage into a secure, trackable, intelligently managed system. From storage to retrieval and lifecycle control, every record is protected, organized, and accessible when you need it.
</p>`,
  boxes: [
    {
      img: "/assets/images/physical-security-img-1.webp",
      label: "Secure Storage Infrastructure"
    },
    {
      img: "/assets/images/physical-security-img-2.webp",
      label: "Compliance Automation"
    },
    {
      img: "/assets/images/physical-security-img-3.webp",
      label: "Environmental Control (humidity, fire safety)"
    },
    {
      img: "/assets/images/physical-security-img-4.webp",
      label: "Efficient Retrieval & Indexing System"
    },
    {
      img: "/assets/images/physical-security-img-5.webp",
      label: "Barcode / RFID Tracking"
    },
    {
      img: "/assets/images/physical-security-img-6.webp",
      label: "Seamless Integration"
    },
    {
      img: "/assets/images/physical-security-img-7.webp",
      label: "Advanced Analytics"
    },
    {
      img: "/assets/images/physical-security-img-8.webp",
      label: "Digitization & Hybrid Access"
    },

  ]
}

const growthData = {
  head: "95% of customers say Dox and Box’s physical records management drives efficiency and business growth.",
  btn: "Book Consultation",
  newClass: "",
  slug: '',
}

const accordData = {
  head: "Intelligent Physical Records Ecosystem",
  desc: "Create a smarter environment for managing high-volume physical documents across locations and departments.",

  boxes: [
    {
      head: "Adaptive Record Structuring",
      para: 'Organize records based on usage frequency, department needs, business priority. This ensures faster retrieval and long-term efficiency.',
      img: "/assets/images/physical-docs-img-1.webp",
    },
    {
      head: "Precision Access Governance",
      para: 'Control who can access, request, or move records with strict authorization protocols and complete audit visibility.',
      img: "/assets/images/physical-docs-img.webp",
    },
    {
      head: "Unified Record Integrity",
      para: 'Maintain consistency and traceability across all stored records with standardized labeling, indexing, tracking systems.',
      img: "/assets/images/physical-docs-img-3.webp",
    },
    {
      head: "Connected Information Flow",
      para: 'Align physical records with your operational workflows so documents are always available where they are needed.',
      img: "/assets/images/physical-docs-img-4.webp",
    },
  ]
}

const accordData2 = {
  head: "Operational Record Flow Optimization",
  desc: "Enhance how physical records move, interact, perform within your organization.",
  boxes: [
    {
      head: "Movement Pattern Analysis",
      para: 'Track how records travel across teams and locations. Reduce redundant handling and improve operational efficiency.',
      img: "/assets/images/physical-operational-img-1.webp",

    },
    {
      head: "Bottleneck Detection System",
      para: 'Identify delays in record retrieval, approvals, or transfers. Streamline processes and reduce downtime.',
      img: "/assets/images/physical-operational-img-2.webp",

    },
    {
      head: "Priority-Based Record Handling",
      para: 'Ensure frequently accessed or high-value records are processed and retrieved faster through priority workflows.',
      img: "/assets/images/physical-operational-img-3.webp",
    },
    {
      head: "Standardized Handling Framework",
      para: 'Implement consistent protocols for storage, retrieval, transportation. Reduce errors and improve compliance.',
      img: "/assets/images/physical-operational-img-4.webp",
    },
  ]
}

const storageData = {
  head: "Why Choose Off Site Physical Record Storage?",
  desc: `<p>Secure, scalable, <b>cost-efficient storage</b> without compromising accessibility.</p>`,
  boxes: [
    {
      img: "/assets/images/physical-storage-icon-1.webp",
      label: "Save valuable office space"
    },

    {
      img: "/assets/images/physical-storage-icon-2.webp",
      label: "Reduce storage and operational costs"
    },

    {
      img: "/assets/images/physical-storage-icon-3.webp",
      label: "Protect documents from damage, theft, loss"
    },

    {
      img: "/assets/images/physical-storage-icon-4.webp",
      label: "Strengthen compliance and audit readiness"
    },

    {
      img: "/assets/images/physical-storage-icon-5.webp",
      label: "Improve organization and retrieval speed"
    },

    {
      img: "/assets/images/physical-storage-icon-6.webp",
      label: "Minimize staff time spent on manual handling"
    },
  ]

}

const adoptData = {
  firstimg: "assets/images/physical-adopt-blur.webp",
  secondimg: "/assets/images/physical-adopt-img1.webp",
  thirdimg: "/assets/images/physical-adopt-img2.webp",
  name: "Ritesh Verma",
  position: "General Manager",
  desc: "Dox and Box streamlined our document workflows and eliminated manual bottlenecks. The system is secure, reliable, easy for teams to adopt. We’ve seen faster turnaround times and better compliance tracking, improving operational efficiency while reducing costs."
}

const faqData = {
  image:"/assets/images/physical-faq-img.webp",
  faqs:[
    {
      question:"How secure is your physical records storage?",
      answer:"Our facilities are designed with multiple layers of security, including restricted access controls, surveillance systems, secure handling protocols. Every record is tracked, monitored, protected against unauthorized access, damage, or loss."
    },
    {
      question:" How quickly can I access or retrieve my documents?",
      answer:"We offer fast and reliable retrieval services based on your needs. Whether you require scheduled access or urgent retrieval, our structured indexing and tracking system ensures your records are located and delivered efficiently."
    },
    {
      question:" Can I track the movement of my physical records?",
      answer:"Yes. Every record movement is logged and monitored through our tracking system. You get full visibility into where your documents are, who accessed them, when they were moved."
    },
    {
      question:"What types of documents can you store?",
      answer:"We handle a wide range of physical records, including legal files, financial documents, HR records, medical records, archival materials. Our storage solutions are designed to accommodate different formats and retention requirements."
    },
    {
      question:"How does off-site storage help reduce costs?",
      answer:"Off-site storage eliminates the need for expensive office space and reduces administrative overhead. It also minimizes risks related to document damage or loss, helping you avoid costly disruptions and compliance issues."
    },
  ]
}

export default function PhysicalRecords() {
  return (
    <>
      <PhysicalBanner data={physicalData} />
      <PhysicalSecurity data={securityData} />
      <PhysicalClientLogo />
      <PhysicalDocs data={accordData} />
      <PhysicalCycle />
      <PhysicalDocsLeft data={accordData2} />
      <PhysicalGrowth data={growthData} />
      <PhysicalStorage data={storageData} />
      <PhysicalAfter />
      <PhysicalTool countData={countData} />
      <PhysicalAdopt data={adoptData} />
      <PhysicalFaq data={faqData} />
    </>
  )
}











